import { z } from 'zod';
import { defineEndpoint } from '../define';
import { MachineSchema } from './shapes';

/** All monitored machines (a handful — no pagination; filters run client-side). */
export const listRunnerMachines = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/machines',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(MachineSchema) }),
});
